import SectionHeading from "./SectionHeading";
import { weeklySchedule } from "@/mocks/shows";

const dayNames = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

export default function Schedule() {
  const today = dayNames[new Date().getDay()];

  return (
    <section id="schedule" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="追剧日历"
          title="一周更新安排，提前知道哪天有新集"
          description="把新的更新节奏集中列出，方便你一次性安排观看计划。标注为「今日」的这一天，说明当天有剧集计划更新。"
        />

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7">
          {weeklySchedule.map((item) => {
            const isToday = item.day === today;
            return (
              <article
                key={item.day}
                className={`reveal flex flex-col rounded-lg border p-4 transition-colors ${
                  isToday
                    ? "border-primary-400 bg-primary-50"
                    : "border-background-200 bg-background-50"
                }`}
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-sm font-bold text-foreground-950">
                    {item.day}
                  </h3>
                  {isToday ? (
                    <span className="rounded-full bg-primary-500 px-2 py-0.5 text-[10px] font-medium text-background-50">
                      今日
                    </span>
                  ) : null}
                </div>
                <ul className="mt-3 flex flex-col gap-2.5">
                  {item.shows.map((show) => (
                    <li
                      key={show}
                      className="flex items-start gap-2 text-xs leading-6 text-foreground-600"
                    >
                      <span
                        className={`mt-2 h-1.5 w-1.5 shrink-0 rounded-full ${
                          isToday ? "bg-primary-500" : "bg-accent-500"
                        }`}
                      ></span>
                      <span>{show}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>

        <p className="reveal mt-6 flex items-start gap-2 text-xs leading-6 text-foreground-500">
          <i className="ri-information-line mt-0.5 text-base text-secondary-500"></i>
          更新安排为常规排期，遇到节假日或平台调整时可能顺延，具体以剧集页面的最新标注为准。
        </p>
      </div>
    </section>
  );
}